export default __webpack_public_path__ + "static/media/oh-my.60a2f580.gif";